import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-balham.css"; // Optional Theme applied to the grid
import "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";

import { globalAGGridTableHeight } from "@/components/widgets/tradeActionSummary/helper/actionSummaryHelper";

import { formatNumberWithCommas } from "@/lib/utilities";
import { IBaseAnalyticsCombined } from "@/store/analyticsDataStore";
import { ColDef } from "ag-grid-community";
import { useTheme } from "next-themes";
import React, { SetStateAction, useMemo, useRef, useState } from "react";
import {
  defaultColDefAnalytics,
  genericAnalyticsTables,
} from "../../TableGenerics";
import { ITransactionCostFilters } from "../TransactionCostIndex";
import { returnKeysToMapGeneric } from "../../analyticsHelperFunctions";

const TransactionCostCurrency = ({
  data,
  filteredData,
  dataFilters,
  setDataFilters,
}: {
  data: IBaseAnalyticsCombined[];
  filteredData: IBaseAnalyticsCombined[];
  dataFilters: ITransactionCostFilters;
  setDataFilters: React.Dispatch<SetStateAction<ITransactionCostFilters>>;
}) => {
  const { theme } = useTheme();
  const gridRef = useRef<AgGridReact>(null);

  function aggregateDataForCurrencyTable() {
    const filteredDataObject = filteredData.reduce((acc: any, obj) => {
      const transactionCostCurrencyObject = {
        securityType: "",
        spreadToMid: 0,
        DV01: 0,
        tradeCostVsMid: 0,
        count: 0,
      };
      if (!acc[obj.securityType]) {
        acc[obj.securityType] = transactionCostCurrencyObject;
        acc[obj.securityType].securityType = obj.securityType;
      }
      acc[obj.securityType].count = acc[obj.securityType].count + 1;
      acc[obj.securityType].spreadToMid =
        Math.abs(Number(obj.spreadToMid)) + acc[obj.securityType].spreadToMid;
      acc[obj.securityType].DV01 =
        Number(obj.DV01) + acc[obj.securityType].DV01;
      acc[obj.securityType].tradeCostVsMid =
        Number(obj.tradeCostVsMid) + acc[obj.securityType].tradeCostVsMid;
      return acc;
    }, {});

    const dataInFinalArr = [];
    for (const key in filteredDataObject) {
      if (Object.prototype.hasOwnProperty.call(filteredDataObject, key)) {
        const element = filteredDataObject[key];
        element.dv01 = (element.DV01 / element.count).toFixed(2);
        element.spreadToMid = (element.spreadToMid / element.count).toFixed(2);
        element.tradeCostVsMid = (
          element.tradeCostVsMid / element.count
        ).toFixed(2);

        dataInFinalArr.push(element);
      }
    }

    return dataInFinalArr;
  }

  const [colDefs] = useState<ColDef[]>([
    {
      checkboxSelection: true,
      lockPosition: "left",
      cellRenderer: "agGroupCellRenderer",
      field: "",
      headerName: " ",
      colId: "securityTypeTransactionCost",
      maxWidth: 40,
    },
    {
      field: "securityType",
      colId: "securityTypeTransactionCost",

      maxWidth: 120,
    },
    {
      field: "spreadToMid",
      colId: "spreadToMidTransactionCost",
      maxWidth: 110,
    },
    {
      field: "dv01",
      headerName: "DV01",
      colId: "DV01TransactionCost",
      maxWidth: 110,
      cellRenderer: (params: any) => {
        if (Number.isNaN(Number(params.value))) {
          return "";
        }
        return `$${formatNumberWithCommas(Number(params.value))}`;
      },
    },
    {
      field: "tradeCostVsMid",
      colId: "tradingCostVsMid",
      maxWidth: 150,
      cellRenderer: (params: any) => {
        if (Number.isNaN(Number(params.value))) {
          return "";
        }
        return `$${formatNumberWithCommas(Number(params.value))}`;
      },
    },
  ]);

  const style = useMemo(
    () => genericAnalyticsTables(theme) as React.CSSProperties,
    [theme],
  );
  return (
    <div className="flex h-full w-full flex-col">
      <div
        id="CPReportTable"
        className={`${theme == "dark" ? "ag-theme-balham-dark" : "ag-theme-balham"} flex h-full w-full flex-col  `}
        style={style}
      >
        <AgGridReact
          ref={gridRef}
          rowData={aggregateDataForCurrencyTable()}
          columnDefs={colDefs}
          defaultColDef={defaultColDefAnalytics}
          columnMenu={"new"} //do not delete, affects header menus
          detailRowAutoHeight={true}
          getRowId={(params) => params.data.securityType}
          // rowSelection={"single"}
          rowSelection={"multiple"}
          suppressRowClickSelection={false}
          rowMultiSelectWithClick={true}
          onSelectionChanged={(params) => {
            const selectedRows = params.api.getSelectedRows();
            if (selectedRows && selectedRows.length > 0) {
              const securitySelected: string[] = [];
              selectedRows.forEach((row) =>
                securitySelected.push(row.securityType),
              );
              setDataFilters({
                ...dataFilters,
                selectedSecurities: securitySelected,
              });
            } else {
              const secKeys = [
                "securityType",
              ] as (keyof IBaseAnalyticsCombined)[];
              const { securityTypeKeys } = returnKeysToMapGeneric(
                data,
                secKeys,
              );
              setDataFilters({
                ...dataFilters,
                selectedSecurities: securityTypeKeys,
              });
            }
          }}
          suppressAggFuncInHeader={true}
          suppressDragLeaveHidesColumns={true}
          // Style:
          rowHeight={globalAGGridTableHeight}
          scrollbarWidth={6}
          // groupDisplayType={"groupRows"}
          animateRows={true} // Smoother transition of rows when updates occur - needs 'getRowId' for this to work.
          maintainColumnOrder={true}
          // components={}
          tooltipShowDelay={1}
          domLayout="normal"
        />
      </div>
    </div>
  );
};

export default TransactionCostCurrency;
